export default __webpack_public_path__ + "static/media/lockScreen.9e76357a.svg";